import type { ReactNode } from 'react';
import { brandAssets } from '../brand-assets';
import { brandingLogoAlt } from '../skin-meta';

const LoadingDots = () => (
  <div className="flex items-center gap-2">
    <span className="loading-dot h-3 w-3 rounded-full" />
    <span className="loading-dot h-3 w-3 rounded-full" />
    <span className="loading-dot h-3 w-3 rounded-full" />
  </div>
);

const BrandedShell = ({ children }: { children: ReactNode }) => (
  <main className="relative flex min-h-dvh flex-col items-center justify-center overflow-hidden bg-black text-text-primary">
    {brandAssets ? (
      <img
        src={brandAssets.loadingBg}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />
    ) : null}

    <div aria-hidden="true" className="loading-overlay absolute inset-0" />

    <div className="relative z-10 flex flex-1 flex-col items-center justify-center">
      {brandAssets ? (
        <img
          src={brandAssets.trophy}
          alt="Spin To Win"
          className="h-auto w-[260px] object-contain drop-shadow-[0_16px_28px_rgba(0,0,0,0.45)]"
        />
      ) : null}
    </div>

    <div className="relative z-10 flex flex-col items-center gap-10 pb-12">
      {children}

      {brandAssets ? (
        <img
          src={brandAssets.brandingLogo}
          alt={brandingLogoAlt}
          className="h-auto w-[160px] object-contain"
        />
      ) : null}
    </div>
  </main>
);

export const LoadingScreen = () => (
  <BrandedShell>
    <LoadingDots />
  </BrandedShell>
);

export const ErrorScreen = ({ message }: { message: string }) => (
  <BrandedShell>
    <div role="alert" className="max-w-xs space-y-2 text-center">
      <h1 className="text-lg font-semibold text-text-primary">Something went wrong</h1>
      <p className="text-sm text-text-secondary">{message}</p>
    </div>
  </BrandedShell>
);
